/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'jquery',
	'doT',
	'text!./ExpandEdges.html',
	'../../../../app/nls/StringResources'
], function(Class, $, dot, Template, stringResources) {

	const ExpandAction = Class.extend({
		init: function (controller) {
			this.controller = controller;
		},
		newSelection: function(nodes) {
			const iconsFeature = this.controller.dashboardApi.getFeature('Icons');
			const expandIcon = iconsFeature.getIcon('maximize');
			const html = dot.template(Template)({
				expandIcon: expandIcon.id
			});
			// Only show the expand action for widgets that are maximizable.
			$(nodes)
				.filter('.maximizable')
				.append(html)
				.find('.expandHandle')
				.attr('title', stringResources.get('expandHandle'))
				.on('primaryaction', this.onExpand.bind(this));
		},

		onExpand: function(event) {
			const node = $(event.target).closest('.maximizable');

			if (node.length) {
				var n = node[0];
				if (n._layout) {
					n._layout.onMaximize();
				}
			}
		}

	});

	return ExpandAction;

});
